function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2135 62.1915H13.0175C13.0175 54.34 7.98966 47.9895 1.80603 47.9895V45.7957C9.20328 45.7957 15.2135 53.1853 15.2135 62.1915Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2134 62.1917H13.0173C13.0173 53.1278 19.0276 45.7959 26.4248 45.7959V47.9897C20.2412 47.9897 15.2134 54.3979 15.2134 62.1917Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.3061 -18.6652L24.723 209.548L26.9191 209.554L27.5021 -18.6596L25.3061 -18.6652Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9825 -18.6217L12.3994 209.592L14.5955 209.597L15.1785 -18.6161L12.9825 -18.6217Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M37.3608 -18.6313L36.7778 209.582L38.9738 209.588L39.5569 -18.6257L37.3608 -18.6313Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2135 50.0103H13.0175C13.0175 42.1588 7.98966 35.8083 1.80603 35.8083V33.6145C9.20328 33.6145 15.2135 41.0042 15.2135 50.0103Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2134 50.0103H13.0173C13.0173 40.9464 19.0276 33.6145 26.4248 33.6145V35.8083C20.2412 35.866 15.2134 42.2165 15.2134 50.0103Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2135 37.4822H13.0175C13.0175 29.6307 7.98966 23.2802 1.80603 23.2802V21.0864C9.20328 21.0864 15.2135 28.4761 15.2135 37.4822Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2134 37.4822H13.0173C13.0173 28.4184 19.0276 21.0864 26.4248 21.0864V23.2802C20.2412 23.2802 15.2134 29.6884 15.2134 37.4822Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6013 62.1915H37.4052C37.4052 54.34 32.3774 47.9895 26.1938 47.9895V45.7957C33.591 45.7957 39.6013 53.1853 39.6013 62.1915Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6013 62.1917H37.4052C37.4052 53.1278 43.4155 45.7959 50.8127 45.7959V47.9897C44.6291 47.9897 39.6013 54.3979 39.6013 62.1917Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6013 50.0103H37.4052C37.4052 42.1588 32.3774 35.8083 26.1938 35.8083V33.6145C33.591 33.6145 39.6013 41.0042 39.6013 50.0103Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6013 50.0103H37.4052C37.4052 40.9464 43.4155 33.6145 50.8127 33.6145V35.8083C44.6291 35.866 39.6013 42.2165 39.6013 50.0103Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6013 37.4822H37.4052C37.4052 29.6307 32.3774 23.2802 26.1938 23.2802V21.0864C33.591 21.0864 39.6013 28.4761 39.6013 37.4822Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6013 37.4822H37.4052C37.4052 28.4184 43.4155 21.0864 50.8127 21.0864V23.2802C44.6291 23.2802 39.6013 29.6884 39.6013 37.4822Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2135 25.3587H13.0175C13.0175 17.5072 7.98966 11.1567 1.80603 11.1567V8.96289C9.20328 8.96289 15.2135 16.3526 15.2135 25.3587Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2134 25.3587H13.0173C13.0173 16.2948 19.0276 8.96289 26.4248 8.96289V11.1567C20.2412 11.1567 15.2134 17.5649 15.2134 25.3587Z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6013 25.3587H37.4052C37.4052 17.5072 32.3774 11.1567 26.1938 11.1567V8.96289C33.591 8.96289 39.6013 16.3526 39.6013 25.3587Z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6013 25.3587H37.4052C37.4052 16.2948 43.4155 8.96289 50.8127 8.96289V11.1567C44.6291 11.1567 39.6013 17.5649 39.6013 25.3587Z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M49.804 -18.6705L49.2209 209.543L51.4169 209.549L52 -18.6649L49.804 -18.6705Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M0.808046 -18.6596L0.224976 209.554L2.42103 209.56L3.0041 -18.654L0.808046 -18.6596Z"
});

var SvgIcoHleb = function SvgIcoHleb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 60,
    viewBox: "0 0 52 60",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoHleb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-hleb.17f43e40.svg";
export { ForwardRef as ReactComponent };